import { render } from "./Basic.vue?vue&type=template&id=73a2f9a8"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"
script.render = render

export default script